import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  AdminKdsAuditView,
  AdminKdsAuditPage,
  AdminKdsAuditQuery,
  KitchenStatus,
  KdsAuditHistoryView,
} from 'shared-models/browser';

export type {
  AdminKdsAuditPage,
  AdminKdsAuditQuery,
  AdminKdsAuditSortKey,
  AdminKdsAuditView,
  KdsAuditHistoryEntryView,
  KdsAuditHistoryView,
} from 'shared-models/browser';

export type UpdateAdminKdsStatusPayload = {
  status: KitchenStatus | null;
};

class AdminKdsAuditService {
  async list(query: AdminKdsAuditQuery = {}): Promise<AdminKdsAuditPage> {
    try {
      const response = await authenticatedInstance.get<AdminKdsAuditPage>('/kds/admin/audit', { params: query });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת יומן המטבח נכשלה'));
    }
  }

  async history(orderlineId: number): Promise<KdsAuditHistoryView> {
    try {
      const response = await authenticatedInstance.get<KdsAuditHistoryView>(`/kds/admin/audit/${orderlineId}/history`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת ההיסטוריה נכשלה'));
    }
  }

  async update(orderlineId: number, payload: UpdateAdminKdsStatusPayload): Promise<AdminKdsAuditView> {
    try {
      const response = await authenticatedInstance.patch<AdminKdsAuditView>(`/kds/admin/audit/${orderlineId}/status`, payload);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון סטטוס המטבח נכשל'));
    }
  }

  async selectionHistory(selectionId: number): Promise<KdsAuditHistoryView> {
    try {
      const response = await authenticatedInstance.get<KdsAuditHistoryView>(`/kds/admin/audit/selection/${selectionId}/history`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת ההיסטוריה נכשלה'));
    }
  }

  async updateSelection(selectionId: number, payload: UpdateAdminKdsStatusPayload): Promise<AdminKdsAuditView> {
    try {
      const response = await authenticatedInstance.patch<AdminKdsAuditView>(`/kds/admin/audit/selection/${selectionId}/status`, payload);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון סטטוס המטבח נכשל'));
    }
  }
}

export const adminKdsAuditService = new AdminKdsAuditService();
